if (!document.URL.includes("orders")) {
  window.addEventListener("load", function () {
    var _learnq = window._learnq || [];
    function addedToCart() {
      fetch(`${window.location.origin}/cart.js`).then((res) =>
        res
          .clone()
          .json()
          .then((data) => {
            var cart = {
              total_price: data.total_price / 100,
              $value: data.total_price / 100,
              total_discount: data.total_discount,
              original_total_price: data.original_total_price / 100,
              items: data.items,
            };
            if (item !== "undefined") {
              cart = Object.assign(cart, item);
            }
            if (klAjax) {
              _learnq.push(["track", "Added to Cart", cart]);
              klAjax = !1;
            }
          })
      );
    }
    (function (ns, fetch) {
      ns.fetch = function () {
        const response = fetch.apply(this, arguments);
        response.then((res) => {
          if (`${window.location.origin}/cart/add.js`.includes(res.url)) {
            addedToCart();
          }
        });
        return response;
      };
    })(window, window.fetch);
    var klAjax = !0;
    var atcButtons = document.querySelectorAll(
      "form[action*='/cart/add'] button[type='submit']"
    );
    for (var i = 0; i < atcButtons.length; i++) {
      atcButtons[i].addEventListener("click", function () {
        if (klAjax) {
          _learnq.push(["track", "Added to Cart", item]);
          klAjax = !1;
        }
      });
    }
  });
  $(".opt-label").click(function () {
    var labelText = $(this).text();
    $(this)
      .closest("fieldset")
      .find(".option-selector__label-value")
      .text(labelText);
  });
}
$(document).ready(function () {
  var htmlContent = $(".product-label-container").html();
});
$(document).ready(function () {
  var matchTitle = "Gorvex Faq Chat";
  $("a").each(function () {
    var $link = $(this);
    if ($link.attr("title") === matchTitle) {
      $link.attr(
        "onclick",
        'document.querySelector("#ShopifyChat").shadowRoot.querySelector("button.chat-toggle").click();'
      );
      $link.attr("href", "javascript:void(0);");
    }
  });
  $(".service-policy-modal iframe").css("height", "500px");
});
function validateInput(input) {
  input.value = input.value.replace(/\D/g, "");
  if (input.value.length < 10) {
    input.setCustomValidity("Phone number must be at least 10 digits.");
  } else if (input.value.length > 13) {
    input.setCustomValidity("Phone number must be no more than 13 digits.");
  } else {
    input.setCustomValidity("");
  }
}
$(".toggle-password").click(function () {
  var passwordField = $("#register-password , #customer-password, #password ");
  var fieldType = passwordField.attr("type");
  var eyeIcon =
    "https://cdn.shopify.com/s/files/1/0560/0817/9783/files/eye.svg?v=1721469991";
  var eyeOffIcon =
    "https://cdn.shopify.com/s/files/1/0560/0817/9783/files/eye-off.svg?v=1721469991";
  if (fieldType === "password") {
    passwordField.attr("type", "text");
    $(".eye-icon").attr("src", eyeOffIcon);
  } else {
    passwordField.attr("type", "password");
    $(".eye-icon").attr("src", eyeIcon);
  }
});
$(".toggle-password-confirm").click(function () {
  var passwordField = $("#password-confirm ");
  var fieldType = passwordField.attr("type");
  var eyeIcon =
    "https://cdn.shopify.com/s/files/1/0560/0817/9783/files/eye.svg?v=1721469991";
  var eyeOffIcon =
    "https://cdn.shopify.com/s/files/1/0560/0817/9783/files/eye-off.svg?v=1721469991";
  if (fieldType === "password") {
    passwordField.attr("type", "text");
    $(".eye-icon1").attr("src", eyeOffIcon);
  } else {
    passwordField.attr("type", "password");
    $(".eye-icon1").attr("src", eyeIcon);
  }
});
function checkPasswordStrength() {
  var number = /([0-9])/;
  var alphabets = /([a-zA-Z])/;
  var special_characters = /([~,!,@,#,$,%,^,&,*,-,_,+,=,?,>,<])/;
  var password = $("#register-password").val().trim();
  if (password.length < 6) {
    $("#password-strength-status").removeClass();
    $("#password-strength-status").addClass("weak-password");
    $("#password-strength-status").html(
      "Weak ( Should include numbers, letters and symbols.)"
    );
  } else {
    if (
      password.match(number) &&
      password.match(alphabets) &&
      password.match(special_characters)
    ) {
      $("#password-strength-status").removeClass();
      $("#password-strength-status").addClass("strong-password");
      $("#password-strength-status").html("Strong");
    } else {
      $("#password-strength-status").removeClass();
      $("#password-strength-status").addClass("medium-password");
      $("#password-strength-status").html(
        "Medium ( Should include numbers, letters and symbols.)"
      );
    }
  }
}
function checkPasswordStrength1() {
  var number = /([0-9])/;
  var alphabets = /([a-zA-Z])/;
  var special_characters = /([~,!,@,#,$,%,^,&,*,-,_,+,=,?,>,<])/;
  var password = $("#password").val().trim();
  if (password.length < 6) {
    $("#password-strength-status1").removeClass();
    $("#password-strength-status1").addClass("weak-password");
    $("#password-strength-status1").html(
      "Weak ( Should include numbers, letters and symbols.)"
    );
  } else {
    if (
      password.match(number) &&
      password.match(alphabets) &&
      password.match(special_characters)
    ) {
      $("#password-strength-status1").removeClass();
      $("#password-strength-status1").addClass("strong-password");
      $("#password-strength-status1").html("Strong");
    } else {
      $("#password-strength-status1").removeClass();
      $("#password-strength-status1").addClass("medium-password");
      $("#password-strength-status1").html(
        "Medium ( Should include numbers, letters and symbols.)"
      );
    }
  }
}
function checkPasswordStrength2() {
  var number = /([0-9])/;
  var alphabets = /([a-zA-Z])/;
  var special_characters = /([~,!,@,#,$,%,^,&,*,-,_,+,=,?,>,<])/;
  var password = $("#password-confirm").val().trim();
  if (password.length < 6) {
    $("#password-strength-status2").removeClass();
    $("#password-strength-status2").addClass("weak-password");
    $("#password-strength-status2").html(
      "Weak ( Should include numbers, letters and symbols.)"
    );
  } else {
    if (
      password.match(number) &&
      password.match(alphabets) &&
      password.match(special_characters)
    ) {
      $("#password-strength-status2").removeClass();
      $("#password-strength-status2").addClass("strong-password");
      $("#password-strength-status2").html("Strong");
    } else {
      $("#password-strength-status2").removeClass();
      $("#password-strength-status2").addClass("medium-password");
      $("#password-strength-status2").html(
        "Medium ( Should include numbers, letters and symbols.)"
      );
    }
  }
}
document.addEventListener("DOMContentLoaded", function () {
  const emailInput = document.querySelector("#customer-email");
  if (emailInput) {
    emailInput.setCustomValidity("Email address is invalid");
    emailInput.addEventListener("input", function () {
      if (emailInput.validity.typeMismatch) {
        emailInput.setCustomValidity("Email address is invalid");
      } else {
        emailInput.setCustomValidity("");
      }
    });
    document
      .querySelector("#customer_login")
      .addEventListener("submit", function (e) {
        if (!emailInput.validity.valid) {
          emailInput.reportValidity();
          e.preventDefault();
        }
      });
  }
});
document.addEventListener("DOMContentLoaded", function () {
  const registeremailInput = document.querySelector("#register-email");
  if (registeremailInput) {
    registeremailInput.setCustomValidity("Email address is invalid");
    registeremailInput.addEventListener("input", function () {
      if (registeremailInput.validity.typeMismatch) {
        registeremailInput.setCustomValidity("Email address is invalid");
      } else {
        registeremailInput.setCustomValidity("");
      }
    });
    document
      .querySelector("#create_customer")
      .addEventListener("submit", function (e) {
        if (!registeremailInput.validity.valid) {
          registeremailInput.reportValidity();
          e.preventDefault();
        }
      });
  }
});
$(".jdgm-submit-rev").click(function () {
  $("html,body").animate(
    { scrollTop: $(".review-tab-detail").offset().top },
    "slow"
  );
});
$(".sticky-add-cart").click(function () {
  $(".product-info__add-button button").click();
});
